import {React} from 'common'
import {useI18n} from 'store/Store'
import {styled} from '@mui/material'
import {Colors, Texts} from 'appearance'

const HeaderTitle = () => {
    const {i18n} = useI18n()
    return (
        <Title noWrap sx={{display: {xs: 'none', sm: 'block'}}}>
            {i18n.t('header.title')}
        </Title>
    )
}

export default HeaderTitle

const Title = styled(Texts.RegularText)`
    font-size: 22px;
    font-weight: 700;
    color: ${Colors.PRIMARY_TEXT};
`
